// @flow
import type { StateType } from '../reducers';

export const isLoggedInSelector = (state: StateType): boolean => !!state.auth?.token;

export const tokenSelector = (state: StateType): string | null => {
  const token = state.auth?.token;

  if (!token) {
    return null;
  }

  return token;
};

export const deviceIdSelector = (state: StateType): string | null => {
  return state.auth.deviceId;
};
